export default __webpack_public_path__ + "static/media/belt_of_the_defiant.969bc8da.jpg";